'use client'

import React, { ReactElement } from 'react'

import { SwitcherFilter, SwitcherFilterProps } from '../Filter'

interface TimelineSwitcherFilterProps extends SwitcherFilterProps {}

export const TimelineSwitcherFilter = ({ ...props }: TimelineSwitcherFilterProps): ReactElement => {
    return <SwitcherFilter isStretched className="h-10" {...props} />
}
